import { render, staticRenderFns } from "./table-wuliao.vue?vue&type=template&id=0119a31a&scoped=true"
import script from "./table-wuliao.vue?vue&type=script&lang=js"
export * from "./table-wuliao.vue?vue&type=script&lang=js"
import style0 from "./table-wuliao.vue?vue&type=style&index=0&id=0119a31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0119a31a",
  null
  
)

export default component.exports